// ─────────────────────────────────────────────────────────────────────────────
// Products feature — API давхарга. Бараа CRUD + зураг + draft (зураггүй бараа).
// ─────────────────────────────────────────────────────────────────────────────
import AxiosRequest from "shared/api/httpClient";

/**
 * Барааны жагсаалт (хуудас/ангилал/хайлт/харагдацаар).
 *
 * `categoryIds` нь эцэг ангилал + түүний бүх үр садын id — шүүлтийг СЕРВЕР
 * хийнэ. Урд талд шүүж байсан нь ангиллын барааг «байхгүй» мэт харуулж,
 * гүйлгэлтийг түгждэг байв. Хуучин дуудагчид (`categoryId`) хэвээр ажиллана.
 */
export async function fetchProducts({
  page,
  pageSize,
  categoryId,
  categoryIds,
  keyword,
  isVisible,
}) {
  return AxiosRequest({
    url: "/merchant/products",
    method: "get",
    params: {
      page,
      pageSize,
      categoryId,
      categoryIds:
        Array.isArray(categoryIds) && categoryIds.length
          ? categoryIds.join(",")
          : undefined,
      keyword,
      isVisible,
    },
  });
}

/** Бараа засах. */
export async function updateProduct(id, payload) {
  return AxiosRequest({
    url: `/merchant/product/update/${id}`,
    method: "post",
    data: payload,
  });
}

/** Бараа устгах. */
export async function deleteProduct(id) {
  return AxiosRequest({
    url: `/merchant/product/delete/${id}`,
    method: "post",
  });
}

/** Шинэ бараа үүсгэх. */
export async function createProduct(body) {
  return AxiosRequest({
    url: "/merchant/product/create",
    method: "post",
    data: body,
  });
}

/** Барааны зураг upload (талбар "file"). */
export async function uploadProductImage(file, id) {
  const formData = new FormData();
  formData.append("file", file);
  return AxiosRequest({
    url: `/upload/image/product/${id}`,
    method: "post",
    isForm: true,
    data: formData,
  });
}

// ── Зураггүй барааны ТҮР (draft) зураг ───────────────────────────────────────

/** Зураггүй барааг жагсаана (өөрийн ч, каталог ч зураггүй). */
export async function fetchImagelessProducts({
  page = 1,
  pageSize = 40,
  keyword,
  onlyNoDraft,
} = {}) {
  return AxiosRequest({
    url: "/merchant/imageless-products",
    method: "get",
    params: { page, pageSize, keyword, onlyNoDraft },
  });
}

/** Барааг аппаас хасах (soft-delete, буцаах боломжтой). */
export async function removeDraftProduct(productId) {
  return AxiosRequest({
    url: `/merchant/draft-remove/${productId}`,
    method: "post",
  });
}

/** Баркод уншуулаад тухайн дэлгүүрийн барааг олно (скан → productId). */
export async function lookupDraftProduct(barcode) {
  return AxiosRequest({
    url: `/merchant/draft-product-lookup/${encodeURIComponent(barcode)}`,
    method: "get",
  });
}

/** Утаснаас авсан зургийг draft болгож хадгална. Талбар ЗААВАЛ "image"
 *  (backend singleImage) — uploadProductImage "file"-аас ЯЛГААТАЙ. */
export async function uploadDraftImage(file, productId) {
  const formData = new FormData();
  formData.append("image", file);
  return AxiosRequest({
    url: `/merchant/draft-images/${productId}`,
    method: "post",
    isForm: true,
    data: formData,
  });
}
